import React, { useLayoutEffect } from 'react'

const portfolioRows = [
  { portfolio: 'Portfolio 1', amount: '16,01,10,736' },
  { portfolio: 'Portfolio 2', amount: '12,69,12,109' },
  { portfolio: 'Portfolio 3', amount: '1,22,05,022' },
  { portfolio: 'Portfolio 4', amount: '97,58,079' },
]

const totalAmount = '30,89,85,946'

export default function DlgDisclosure() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <section className="pt-10 lg:pt-12 blade-bottom-padding-lg min-h-[300px] bg-blueGreen">
        <div className="text-center px-4 mt-6 md:mt-8 lg:mt-0">
          <div className="blade-top-padding blade-top-margin-sm pb-4">
            <h1 className="font-medium text-2xl text-white mxlg:text-3xl 2xl:text-4xl leading-tight">
              ETRIBE FINANCE PRIVATE LIMITED - Website Disclosure
            </h1>
          </div>
        </div>
      </section>

      <section className="w-container blade-top-padding-lg blade-bottom-padding-lg blade-bottom-margin-lg px-3 sm:px-5">
        <div className="max-w-5xl mx-auto text-blueGreen">
          <h2 className="text-xl md:text-2xl font-medium leading-snug">
            DISCLOSURE UNDER GUIDELINES ON DEFAULT LOSS GUARANTEE (DLG)
          </h2>

          <h3 className="text-lg md:text-xl font-medium mt-6 mb-6">
            Total No. of Portfolios: 4
          </h3>

          <div className="overflow-x-auto rounded-lg border border-blueGreen/20">
            <table className="w-full border-collapse">
              <thead className="bg-blueGreen/10">
                <tr>
                  <th className="text-left p-4 text-sm md:text-base font-medium uppercase tracking-wide">
                    Portfolio No
                  </th>
                  <th className="text-left p-4 text-sm md:text-base font-medium uppercase tracking-wide">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {portfolioRows.map((row) => (
                  <tr key={row.portfolio} className="border-t border-blueGreen/15">
                    <td className="p-4 text-sm md:text-base">{row.portfolio}</td>
                    <td className="p-4 text-sm md:text-base">{row.amount}</td>
                  </tr>
                ))}
                <tr className="border-t border-blueGreen/15 bg-blueGreen/5 font-medium">
                  <td className="p-4 text-sm md:text-base">Total</td>
                  <td className="p-4 text-sm md:text-base">{totalAmount}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  )
}
